import type { DynamicFieldValues, DynamicProofingArtwork } from './dynamicProofingFormTypes'
import { Button, Col, Container, Row } from 'reactstrap'
import DynamicArtworkFieldList from './DynamicArtworkFieldList'
import { useDynamicProofingForm } from './useDynamicProofingForm'

type DigitalProofingFormDynamicProps = {
  artwork: DynamicProofingArtwork
  complete: (formData: FormData) => void
  hasRenderingCoupon?: boolean
  overlayGroupsValid?: boolean
  templateFieldsValid?: boolean
  selectedArtworkOverlayIds?: Array<number | string>
  selectedCoupon?: { renders?: boolean }
  onValuesChange?: (values: DynamicFieldValues) => void
}

const DigitalProofingFormDynamic = ({
  artwork,
  complete,
  hasRenderingCoupon,
  overlayGroupsValid,
  templateFieldsValid = true,
  selectedArtworkOverlayIds,
  onValuesChange,
  selectedCoupon
}: DigitalProofingFormDynamicProps) => {
  const {
    values,
    fieldErrors,
    errorMessage,
    isFormValid,
    sortedArtworkFields,
    handleChange,
    handlePreviewProof,
    shiftBulletValue
  } = useDynamicProofingForm({
    artwork,
    complete,
    hasRenderingCoupon,
    selectedArtworkOverlayIds,
    onValuesChange,
    selectedCoupon
  })
  const overlayGroupsInvalid = overlayGroupsValid === false
  const templateFieldsInvalid = templateFieldsValid === false

  return (
    <Container>
      <DynamicArtworkFieldList
        fields={sortedArtworkFields}
        values={values}
        fieldErrors={fieldErrors}
        onChange={handleChange}
        onShiftBulletValue={shiftBulletValue}
      />

      <Row>
        <Col xs={12}>
          <br />
          <Button
            className="button btn-active btn-md mr-15 mf-mb-20 mb-sm-0"
            onClick={handlePreviewProof}
            disabled={
              overlayGroupsInvalid ||
              templateFieldsInvalid ||
              !!errorMessage ||
              isFormValid === false ||
              Object.values(fieldErrors).length > 0
            }
          >
            Preview Proof
          </Button>
          <p>
            <small>
              While the preview image is set to a lower resolution, the final printable version will be in high
              resolution.
            </small>
          </p>
          <br />
          {overlayGroupsInvalid && <p className="red-text">Please complete all required artwork selections.</p>}
          {templateFieldsInvalid && <p className="red-text">Please make all required selections.</p>}
          <p className="red-text">{errorMessage}</p>
          {Object.values(fieldErrors).map(
            (error, index) =>
              error.showInErrorSummary && (
                <p className="red-text" key={index}>
                  {error.message}
                </p>
              )
          )}
        </Col>
      </Row>
    </Container>
  )
}

export default DigitalProofingFormDynamic
